import BaseService from './base.service';

export default class UserService {
    static ENDPOINT = '/users';

    static async getCurrentUser() {
        const endpoint = `${this.ENDPOINT}/me`;
        return BaseService.get(endpoint);
    }

    static async getCurrentOrg() {
        const endpoint = `${this.ENDPOINT}/me/org`;
        return BaseService.get(endpoint);
    }

    static async getUserOrgs() {
        const endpoint = `${this.ENDPOINT}/me/orgs`;
        return BaseService.get(endpoint);
    }
    
    static async getUserProperties() {
        const endpoint = `${this.ENDPOINT}/me/properties`;
        return BaseService.get(endpoint);
    }

    static async getCurrentAccessKeys() {
        const endpoint = `${this.ENDPOINT}/me/access-keys`;
        return BaseService.get(endpoint);
    }

    static async setActiveProperty(userId, propertyId) {
        const endpoint = `${this.ENDPOINT}/${userId}/active-property/${propertyId}`;
        return BaseService.patch(endpoint, null);
    }

    static async uploadPhotoId(file) {
        const endpoint = `${this.ENDPOINT}/me/upload-photo-id`;
        const formData = new FormData();
        formData.append('file', file);

        return BaseService.postFile(endpoint, formData);
    }

    static async getPropertyAccessLogs(orgId, propertyId, params = {}) {
        const { lastAccessTime, limit = 20 } = params;

        const queryParams = new URLSearchParams();
        if (lastAccessTime) {
            queryParams.append('lastAccessTime', lastAccessTime);
        }
        if (limit) {
            queryParams.append('limit', limit.toString());
        }

        const queryString = queryParams.toString();
        const endpoint = `${
            this.ENDPOINT
        }/me/orgs/${orgId}/properties/${propertyId}/access-logs${
            queryString ? `?${queryString}` : ''
        }`;

        return BaseService.get(endpoint);
    }

    static async addNonResiMember(orgId, payload) {
        const endpoint = `${this.ENDPOINT}/orgs/${orgId}/non-resi-members`;
        return BaseService.post(endpoint, payload);
    }

    static async getMyInvites() {
        const endpoint = `${this.ENDPOINT}/me/invites`;
        return BaseService.get(endpoint);
    }

    static async acceptInvite(inviteId) {
        const endpoint = `${this.ENDPOINT}/me/invites/${inviteId}/accept`;
        return BaseService.post(endpoint, null);
    }

    static async denyInvite(inviteId) {
        const endpoint = `${this.ENDPOINT}/me/invites/${inviteId}/deny`;
        return BaseService.post(endpoint, null);
    }

    ////////////////////////// VEHICLE V1 ENDPOINTS ///////////////////////
    static async getMyVehicles() {
        const endpoint = `${this.ENDPOINT}/me/vehicles`;
        return BaseService.get(endpoint);
    }

    static async addMyVehicle(payload) {
        const endpoint = `${this.ENDPOINT}/me/vehicles`;
        return BaseService.post(endpoint, payload);
    }

    static async updateMyVehicle(vehicleId, payload) {
        const endpoint = `${this.ENDPOINT}/me/vehicles/${encodeURIComponent(vehicleId)}`;
        return BaseService.patch(endpoint, payload);
    }

    static async removeMyVehicle(vehicleId) {
        const endpoint = `${this.ENDPOINT}/me/vehicles/${encodeURIComponent(vehicleId)}`;
        return BaseService.delete(endpoint);
    }
}
